import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VApp,
    [
      !_vm.isLogin
        ? _c("b", [
            _c("div", { staticClass: "container_loading" }, [
              _c("div", { staticClass: "content_loading" }, [
                _c("img", {
                  staticStyle: {
                    "padding-top": "2px",
                    "margin-bottom": "4px",
                    width: "250px",
                  },
                  attrs: {
                    "data-v-0c17871c": "",
                    width: "160",
                    src: require("@/assets/inca_200x75.png"),
                  },
                }),
                _c("div", { staticClass: "progress_loading" }),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.isRouterLoaded
        ? _c(
            _vm.currentLayout,
            { tag: "component" },
            [
              _c(
                "transition",
                { attrs: { name: "fade", mode: "out-in" } },
                [_c("router-view")],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        VSnackbar,
        {
          attrs: {
            timeout: _vm.toast.timeout,
            color: _vm.toast.color,
            bottom: "",
          },
          model: {
            value: _vm.toast.show,
            callback: function ($$v) {
              _vm.$set(_vm.toast, "show", $$v)
            },
            expression: "toast.show",
          },
        },
        [
          _vm._v(_vm._s(_vm.toast.message)),
          _vm.toast.timeout === 0
            ? _c(
                VBtn,
                {
                  attrs: { color: "white", text: "" },
                  on: {
                    click: function ($event) {
                      _vm.toast.show = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }